import React, { useState } from 'react';
import styled from 'styled-components';
import { useCart } from '../../contexts/CartContext';
import CartModal from './CartModal';

const CartIconContainer = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 25px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(102, 126, 234, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
  }
`;

const CartIconSvg = styled.svg`
  width: 24px;
  height: 24px;
  fill: currentColor;
`;

const CartCount = styled.span`
  background: #ff4757;
  color: white;
  border-radius: 50%;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${props => props.$hasItems ? 'pulse 2s infinite' : 'none'};

  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
`;

const CartText = styled.span`
  font-weight: 500;
  font-size: 0.875rem;
`;

const CartIcon = () => {
  const { totalItems, totalPrice, isEmpty, isLoaded } = useCart();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <CartIconContainer onClick={() => setIsModalOpen(true)}>
        <CartIconSvg viewBox="0 0 24 24">
          <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
        </CartIconSvg>
        {!isEmpty && (
          <CartCount $hasItems={totalItems > 0}>
            {totalItems}
          </CartCount>
        )}
        <CartText>
          {!isLoaded ? 'Loading...' : (isEmpty ? 'Cart' : `$${totalPrice.toFixed(2)}`)}
        </CartText>
      </CartIconContainer>
      
      {isModalOpen && (
        <CartModal onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};

export default CartIcon;
